import React, { useContext, useState } from "react";
import { createContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "./auth/AuthContext";
import { applySupplierName } from "../utils/supplierName";
function useTitle() {
  const { authState } = useContext(AuthContext);
  const isClient = authState.user?.userName === "Counterparty";
  const { t } = useTranslation(isClient ? "client" : "translation");
  // tog'a 1797 (2026-09-13): boshlang'ich sarlavha «Главная панель» edi — panel olib tashlangani uchun
  // yuklanish lahzasida ham ko'rinmasin; har sahifa o'z SEO sarlavhasini baribir o'rnatadi
  const [title, setStateTitle] = useState<string>("");

  function setTitle(propsTitle: string, override?: string) {
    // tog'a #3481: «Разделы системы» da berilgan nom (hamma tilda) — tarjimadan ustun
    if (override) { setStateTitle(override); return }
    // Farhod (2026-09-02): bola tizimlarda «Закупка завода» o'rniga
    // yetkazib beruvchi nomi ko'rsatiladi — sahifa sarlavhasida ham
    // menyudagi bilan bir xil bo'lsin.
    setStateTitle(applySupplierName(propsTitle, t(propsTitle), authState.user));
  }
  return {
    title,
    setTitle,
  };
}
export const TitleContext = createContext({} as ReturnType<typeof useTitle>);
export function TitleProvider(props: any) {
  return <TitleContext.Provider {...props} value={useTitle()} />;
}
